export default __webpack_public_path__ + "static/2386-ff09285c3f47c346aa7fb81042e43ef5.gif";